<template>
  <AbsPopup id="BookPublicationDate" title="책의 출간일을 선택해 주세요" :initButtonList="buttonList" @close="$emit('close')" @submit="submit">
    <template #body>
      <div class="popup-body" v-if="state !== 1">
        <div>
          <div class="title">
            <span>STEP.01 선독점 희망일 신청</span>
          </div>
          <div v-if="!oneStore.step">
            <div>
              <span>선독점으로 책을 출간하실 서점과 희망일을 선택해 주세요. 선독점을 원하시지 않는 경우 [신청 안함]을 선택 하시면 됩니다. <u>출간 날짜는 서점의 상황에 따라 선택하신 희망일을 기준으로 최대 +1개월 안에 날짜가 선정이 됩니다.</u></span>
            </div>
            <div class="box">
              <div>
                <span>1차 선독점 신청</span>
                <Uselectbox description="선택" :disable="false" :options="getOneStore" @selected="oneStoreSelect" v-model="oneStore.index" />
              </div>
              <div>
                <span>{{ oneStore.year }}</span>
                <TabBar class="month" display="tabBar" :disable="oneStore.index === -1 || oneStore.index === storeList.length" :list="oneStore.monthList" v-model="oneStore.monthIndex" @selected="oneStoreMonth"/>
              </div>
            </div>
            <div class="box">
              <div>
                <span>2차 선독점 신청</span>
                <Uselectbox description="선택" :disable="!isOneStore" :options="getTwoStore" @selected="twoStoreSelect" v-model="twoStore.index" />
              </div>
              <div>
                <span>{{ twoStore.year }}</span>
                <TabBar class="month" :disable="!isOneStore || twoStore.index === -1 || twoStore.index === storeList.length - 1" display="tabBar" :list="twoStore.monthList" v-model="twoStore.monthIndex" @selected="twoStoreMonth"/>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="complete">
              <li>
                <span>1차 선독점</span>
                <span>{{ getOneStore[oneStore.index].text }}</span>
                <span>{{ Store.getMonth(oneStore.value, oneStore.year, oneStore.month) }}</span>
              </li>
              <li>
                <span>2차 선독점</span>
                <span>{{ oneStore.value === Store.NONE ? '없음' : getTwoStore[twoStore.index].text }}</span>
                <span>{{ oneStore.value === Store.NONE ? '' : Store.getMonth(twoStore.value, twoStore.year, twoStore.month) }}</span>
              </li>
            </div>
            <div>
              <span>서점에서 제안하는 프로모션 유무에 따라 정산 비율이 변경될 수 있습니다.</span>
            </div>
          </div>
          <div class="button">
            <Ubutton :text="oneStore.step ? '수정하기' : '확인'" size="small" iconSize="xsmall" :state="(oneStore.step ? 'deactive' : (buttonState ? 'active' : 'disable'))" @click.native="oneStore.step = !oneStore.step"/>
          </div>
        </div>
        <div>
          <div class="title">
            <span>STEP.02 출간 희망일 신청</span>
          </div>
          <div v-if="!oneStore.step">
            <span>선독점 희망일을 선택해 주세요</span>
          </div>
          <div v-else>
            <div v-if="!twoStore.step">
              <div>
                <!-- <span>책을 출간하실 서점을 선택해 주세요.최소 1개 이상의 서점을 선택해 주셔야합니다.<u>출간 날짜는 서점의 상황에 따라 선택하신 희망일을 기준으로 최대 +1개월 안에 날짜가 선정이 됩니다.</u></span> -->
                <span>선독점이 종료된 후의 출간 희망일 및 서점을 선택합니다. 최소 1개 이상의 서점을 선택해주세요. <u>출간 날짜는 선독점 종료일 및 서점의 상황에 따라 선택하신 희망일을 기준으로 1~2개월 가량 날짜가 늦춰질 수 있습니다.</u></span>
              </div>
              <div class="checkboxList">
                <div v-for="(item, index) in storeList" :key="index">
                  <input type="checkbox" :id="'cp' + index" v-model="item.checked" :checked="item.checked"/>
                  <label :for="'cp' + index">{{ item.text }}</label>
                </div>
              </div>
              <div class="box">
                <div>
                  <Ubutton size="small" :text="getStart" state="deactive" @click.native="openCalendar(closest($event.target, 'button'), new Date(start.getTime()), changeStart)">
                    <icon class="abs" size="xsmall" uicon="116" state="guide"/>
                  </Ubutton>
                </div>
                <div>
                  <span>{{ message }}</span>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="complete">
                <li>
                  <span>출간</span>
                  <span>{{ storeMessage }}</span>
                  <span>{{ getStart }}</span>
                </li>
              </div>
              <div>
                <span>서점에서 제안하는 프로모션 유무에 따라 정산 비율이 변경될 수 있습니다.</span>
              </div>
            </div>
            <div class="button">
              <Ubutton :text="twoStore.step ? '수정하기' : '확인'" size="small" iconSize="xsmall" :state="(twoStore.step ? 'deactive' : (isCheck && message === getStart ? 'active' : 'disable'))" @click.native="twoStoreClick"/>
            </div>
          </div>
        </div>
      </div>
      <div class="popup-body" v-else>
        <div>
          <div class="title">
            <span>출간 희망일 추가 신청</span>
          </div>
          <div>
            <div>
              <div>
                <span>책을 출간하실 서점을 선택해 주세요.최소 1개 이상의 서점을 선택해 주셔야합니다.<u>출간 날짜는 서점의 상황에 따라 선택하신 희망일을 기준으로 최대 +1개월 안에 날짜가 선정이 됩니다.</u></span>
              </div>
              <div class="checkboxList">
                <div v-for="(item, index) in storeList" :key="index">
                  <input type="checkbox" :id="'cp' + index" v-model="item.checked" :checked="item.checked" :disabled="item.disabled"/>
                  <label :for="'cp' + index">{{ item.text }}</label>
                </div>
              </div>
              <div class="box">
                <div>
                  <Ubutton size="small" :text="getStart" state="deactive" @click.native="openCalendar(closest($event.target, 'button'), new Date(start.getTime()), changeStart)">
                    <icon class="abs" size="xsmall" uicon="116" state="guide"/>
                  </Ubutton>
                </div>
                <div>
                  <span>{{ message }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import TabBar from '@/components/layout/TabBar.vue'
import {closest, Store, timeToDateString} from '@/components/js/Utils'

export default {
  props: {
    option: {
      type: Object
    }
  },
  created () {
  },
  mounted () {
    var i
    this.start = new Date()
    if (this.start.getDate() > 14) {
      this.start.setMonth(this.start.getMonth() + 1)
      this.start.setDate(1)
    }
    this.oneStore.year = this.start.getFullYear()
    this.twoStore.year = this.start.getFullYear()
    var o = []
    var t = []
    for (i = 0; i < 6; i++) {
      o[i] = {name: (this.start.getMonth() + 1) + '월', year: this.start.getFullYear(), tab: this.start.getMonth()}
      t[i] = {name: (this.start.getMonth() + 1) + '월', year: this.start.getFullYear(), tab: this.start.getMonth()}
      this.start.setMonth(this.start.getMonth() + 1)
    }
    this.oneStore.monthList = o
    this.twoStore.monthList = t
    if (this.option.param) {
      this.start = new Date()
      console.log(timeToDateString(this.start))
      this.oneStore.value = this.option.param.oneStore.value
      var ar = this.getOneStore
      this.oneStore.index = ar.findIndex(item => item.value === this.oneStore.value)
      this.oneStore.month = this.option.param.oneStore.month ? this.option.param.oneStore.month : -1
      this.oneStore.monthIndex = this.oneStore.monthList.findIndex(item => item.tab === this.oneStore.month)
      if (this.oneStore.value === Store.NONE) {
        this.twoStore.value = -1
        this.twoStore.index = -1
        this.twoStore.month = -1
        this.twoStore.monthIndex = -1
        this.oneStore.step = true
        this.twoStore.step = true
        this.message = ''
      } else {
        this.twoStore.value = this.option.param.twoStore.value
        this.start.setFullYear(this.oneStore.year)
        this.start.setMonth(this.oneStore.month)
        this.start.setDate(1)
        for (i = 0; i < 6; i++) {
          this.twoStore.monthList[i] = {name: (this.start.getMonth() + 1) + '월', year: this.start.getFullYear(), tab: this.start.getMonth()}
          this.start.setMonth(this.start.getMonth() + 1)
        }
        ar = this.getTwoStore
        this.twoStore.index = ar.findIndex(item => item.value === this.twoStore.value)
        this.twoStore.month = this.option.param.twoStore.month
        this.twoStore.monthIndex = this.twoStore.monthList.findIndex(item => item.tab === this.twoStore.month)
        this.oneStore.step = true
        this.twoStore.step = true
        this.message = ''
      }
      this.storeList.forEach((item, i) => {
        if (item.value & this.option.param.publishing.store) {
          var k = this.option.param.publishing.storeList.find(st => st.bookstore === item.value)
          console.log(k)
          if (k) {
            if (k.confirm) {
              item.checked = true
              item.disabled = true
            } else {
              item.checked = true
              console.log(k)
              this.start = new Date(k.date)
              this.message = timeToDateString(this.start)
            }
          }
        }
      })
      this.start = this.option.param.publishing.date
      this.storeMessage = Store.getStateString(this.option.param.publishing.store)
      this.state = this.option.param.state
      if (this.state !== 1) {
        this.message = timeToDateString(this.start)
      }
    }
    this.$emit('loading', false)
  },
  data: () => {
    return {
      Store: Store,
      state: 0,
      start: null,
      storeList: Store.getList(),
      oneStore: {
        index: -1,
        value: -1,
        year: '',
        monthIndex: -1,
        month: -1,
        monthList: [],
        step: false
      },
      twoStore: {
        index: -1,
        value: -1,
        year: '',
        monthIndex: -1,
        month: -1,
        monthList: [],
        step: false
      },
      saveSotre: [],
      storeMessage: '',
      message: '',
      tick: false,
      tickHeight: null,
      scrollMax: false,
      closest: closest,
      timeToDateString: timeToDateString
    }
  },
  name: 'BookPublicationDate',
  watch: {
  },
  computed: {
    buttonList () {
      return [
        {name: '취소', state: 'deactive', click: () => { this.$emit('close') }},
        {name: '확인', state: this.isSubmitState, click: this.submit}
      ]
    },
    isOneStore () {
      return this.oneStore.index !== -1 && this.oneStore.month !== -1
    },
    buttonState () {
      return (this.oneStore.index !== -1 && this.oneStore.month !== -1 && this.twoStore.index !== -1 && this.twoStore.month !== -1) || this.oneStore.value === Store.NONE || this.twoStore.value === Store.NONE
    },
    getOneStore () {
      return this.storeList.concat([Store.getNone()])
    },
    getTwoStore () {
      var temp = this.storeList.concat([Store.getNone()])
      var dump = []
      temp.forEach((item, i) => {
        if (this.oneStore.value !== item.value) {
          dump.push(item)
        }
      })
      return dump
    },
    getStart () { return timeToDateString(this.start) },
    isCheck () {
      return this.storeList.some(item => item.checked === true)
    },
    isSubmitState () {
      return this.oneStore.step && this.twoStore.step ? 'active' : 'disable'
    }
  },
  methods: {
    resetDate () {
      this.start = new Date()
      if (this.start.getDate() > 14) {
        this.start.setMonth(this.start.getMonth() + 1)
        this.start.setDate(1)
      }
    },
    resetStep () {
      this.twoStore.step = false
      this.message = ''
    },
    oneStoreSelect (e) {
      console.log(e)
      this.resetStep()
      this.oneStore.value = e.param.value
      if (e.current === this.storeList.length) {
        this.oneStore.monthIndex = -1
        this.oneStore.month = -1
        this.resetDate()
      }
    },
    oneStoreMonth (e) {
      console.log(e)
      this.resetStep()
      this.oneStore.year = e.param.year
      this.oneStore.month = e.param.tab
      this.start.setFullYear(this.oneStore.year)
      this.start.setMonth(this.oneStore.month)
      this.start.setDate(1)
      this.twoStore.monthList = []
      var i
      for (i = 0; i < 6; i++) {
        this.twoStore.monthList[i] = {name: (this.start.getMonth() + 1) + '월', year: this.start.getFullYear(), tab: this.start.getMonth()}
        this.start.setMonth(this.start.getMonth() + 1)
      }
      this.start.setMonth(this.oneStore.month + 1)
      this.start = new Date(this.start.getTime())
      if (this.oneStore.monthIndex === -1) {
        this.twoStore.monthIndex = -1
        this.twoStore.month = -1
        this.twoStore.index = -1
      } else if (this.twoStore.monthIndex !== -1) {
        this.twoStore.year = this.twoStore.monthList[this.twoStore.monthIndex].year
        this.twoStore.month = this.twoStore.monthList[this.twoStore.monthIndex].tab
      }
      console.log(timeToDateString(this.start))
    },
    twoStoreSelect (e) {
      this.resetStep()
      this.twoStore.value = e.param.value
      console.log(e)
      if (e.current === this.storeList.length - 1) {
        this.twoStore.monthIndex = -1
        this.twoStore.month = -1
      }
    },
    twoStoreMonth (e) {
      console.log(e.param.tab)
      this.twoStore.year = e.param.year
      this.twoStore.month = e.param.tab
      this.resetStep()
      this.start.setFullYear(this.twoStore.year)
      this.start.setMonth(this.twoStore.month + 1)
      this.start.setDate(1)
      this.start = new Date(this.start.getTime())
      console.log(timeToDateString(this.start))
    },
    changeStart (e) {
      var d = new Date(e)
      if (this.oneStore.value !== Store.NONE && this.oneStore.month < d.getMonth() && this.twoStore.value !== Store.NONE && this.twoStore.month < d.getMonth()) {
        console.log('ok', this.oneStore.month, this.twoStore.month, d.getMonth())
        this.message = timeToDateString(d)
        this.start = d
      } else if (this.oneStore.value !== Store.NONE && this.oneStore.month < d.getMonth() && this.twoStore.value === Store.NONE) {
        console.log('1 ok', this.twoStore.value)
        this.message = timeToDateString(d)
        this.start = d
      } else if ((new Date()).getTime() < d.getTime()) {
        console.log('3 ok', timeToDateString(new Date()), timeToDateString(d))
        this.message = timeToDateString(d)
        this.start = d
      } else {
        this.message = '잘못 선택된 날짜'
      }
      console.log('changeStart', timeToDateString(this.start))
    },
    twoStoreClick () {
      if (!this.twoStore.step) {
        this.storeMessage = Store.getStateString(Store.changeState(this.storeList))
      }
      this.twoStore.step = !this.twoStore.step
    },
    submit () {
      console.log('ttt', this.state)
      var ar = []
      var temp = []
      if (this.option.param && this.option.param.publishing && this.option.param.publishing.storeList) {
        temp = this.option.param.publishing.storeList
      }
      this.storeList.forEach(item => {
        var k = temp.find(st => st.bookstore === item.value)
        console.log(k)
        if (!item.disabled && (item.checked || k !== undefined)) {
          ar.push({bookstore: item.value, date: this.start, checked: item.checked})
        }
      })
      if (this.state !== 1) {
        this.$emit('submit', {
          oneStore: {value: this.oneStore.value, year: this.oneStore.year, month: this.oneStore.month},
          twoStore: {value: this.twoStore.value, year: this.twoStore.year, month: this.twoStore.month},
          publishing: {store: ar, date: this.start}})
      } else {
        console.log(ar)
        this.$emit('submit', {publishing: {store: ar}})
      }
    }
  },
  components: {
    AbsPopup,
    TabBar
  }
}
</script>

<style scoped>
.popup-body {
  margin: 10px 10px;
  width: 500px;
  text-align: left;
  line-height: 30px;
  display: flex;
  flex-direction: column;
  color: var(--text-base);
}
.popup-body .title {
  font-weight: bold;
  color: var(--text-title);
  border-bottom: 1px solid var(--line-guide);
  width: 100%;
}
.popup-body .line {
  width: 100%;
  border-bottom: 1px solid var(--line-title);
  margin: 5px 0px;
}
.popup-body > div {
  display: flex;
  flex-direction: column;
  margin: 10px 0px;
}
.popup-body .box {
  display: flex;
  flex-direction: row;
  background-color: var(--disable);
  padding: 10px;
  margin-bottom: 10px;
}
.popup-body .box span:first-child {
  color: var(--text-title);
}
.popup-body .box > div {
  display: flex;
  flex-direction: column;
  width: 40%;
}
.popup-body .box > div:last-child {
  width: 60%;
}
.popup-body .box > div + div {
  margin-left: 20px;
}
.button {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.checkboxList {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.checkboxList > div {
  display: flex;
  min-width: 32%;
  /* width: 200px; */
}
.checkboxList > div:nth-child(1n) {
  margin-left: 10px;
  margin-bottom: 10px;
}
.checkboxList > div:nth-child(3n+1) {
  margin-left: 0px;
}
.checkboxList input {
  display: none;
}
.checkboxList input + label {
  position: relative;
  width: 100%;
  height: 100%;
  border: 1px solid var(--line-base);
  color: var(--line-base);
  text-align: center;
  cursor: pointer;
}
.checkboxList input:checked + label {
  background-color: var(--line-title);
  color: var(--bg-white);
}
.checkboxList input:checked + label::after {
  position: absolute;
  content: '\2714';
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}
.complete {
  list-style: none;
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid var(--line-base);
  margin-top: 10px;
}
.complete li {
  display: flex;
  flex-direction: row;
  text-align: center;
}
.complete li span {
  flex: 1;
}
.discription {
  border: 1px solid var(--line-guide);
  padding: 5px;
  line-height: 1.6;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/BookPublicationDate.vue